import axios from 'axios';

const baseUrl = process.env.REACT_APP_QCX_API_BASE_URL! + '/followup/report/acompanhamento-chegada';

const toRange = (inicio: string | null, fim: string | null) =>
  inicio || fim ? `${inicio ?? ''};${fim ?? ''}` : null;

export const generateAcompanhamentoChegadaReport = async (
  token: string,
  unidadeId: string | number,
  tenantIds: string[],
  clientIds: string[],
  aberturaInicio: string | null,
  aberturaFim: string | null,
  chegadaInicio: string | null,
  chegadaFim: string | null
): Promise<string | null> => {
  const params = new URLSearchParams();
  params.set('tenantId', tenantIds.join(','));
  if (clientIds.length) params.set('clientesId', clientIds.join(','));

  const aberturaRange = toRange(aberturaInicio, aberturaFim);
  if (aberturaRange) params.set('aberturaRange', aberturaRange);

  const chegadaRange = toRange(chegadaInicio, chegadaFim);
  if (chegadaRange) params.set('chegadaRange', chegadaRange);

  try {
    const response = await axios.get(`${baseUrl}?${params.toString()}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        quickcomexTenant: unidadeId,
      },
      responseType: 'blob',
      validateStatus: () => true,
    });

    if (response.status === 200) {
      const file = new File([response.data], 'acompanhamento-chegada.xlsx', {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      const url = window.URL.createObjectURL(file);
      const a = document.createElement('a');
      a.href = url;
      a.download = file.name;
      a.click();
      window.URL.revokeObjectURL(url);
      return null;
    }

    const message = await response.data?.text?.();
    return message || 'Erro ao gerar o relatório.';
  } catch {
    return 'Erro ao gerar o relatório.';
  }
};
